import { render, staticRenderFns } from "./Insegnanti.vue?vue&type=template&id=9b4e4b22"
import script from "./Insegnanti.vue?vue&type=script&lang=js"
export * from "./Insegnanti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports